module.exports = __webpack_public_path__ + "img/1948-Cisitalia-202-Cabriolet.302b0198.jpg";